// Open SideDrawer ids; only the top one handles ESC and the Tab focus trap.
let stack: symbol[] = [];

export function push(id: symbol): void {
    stack = [...stack, id];
}

export function remove(id: symbol): void {
    stack = stack.filter((entry) => entry !== id);
}

export function isTop(id: symbol): boolean {
    return stack.length > 0 && stack[stack.length - 1] === id;
}

// Test-only reset.
export function __reset(): void {
    stack = [];
}
